import Image from '@anm/components/image/Image';
import Dialog from '@anm/components/modals/Dialog';
import { flexCenter, CloseButton } from '@anm/styles/helpers';
import styled from 'styled-components';

export const AnimatedBlock = styled.div`
  @keyframes translate {
    0% {
      opacity: 0;
      transform: translateY(100%);
    }
    100% {
      opacity: 1;
    }
  }
  animation: 0.3s translate ease-in-out;
`;

export const CancelButton = styled.div`
  ${flexCenter};
  min-height: 50px;
  font-size: 16px;
  margin-top: 10px;
  font-weight: bold;
  line-height: 20px;
  border-radius: 5px;
  text-align: center;
  background: #ffffff;
`;

export const OptionsWrapper = styled.div`
  background: #ffffff;
  border-radius: 5px;
`;

export const ActionRow = styled.div`
  ${flexCenter};
  display: flex;
  min-height: 50px;
  font-size: 16px;
  font-weight: normal;
  flex-direction: row;
  border-bottom: 1px solid #ccdde6;
  &:last-of-type {
    border: none;
  }
`;

export const ImageWrapper = styled(Image)`
  margin-right: 12.5px;
`;

const DialogWrapper = styled(Dialog)`
  bottom: 0;
  width: 100%;
  position: fixed;
  background: none;
  max-width: 500px;
  padding: 0 19px 25px;
  ${CloseButton} {
    display: none;
  }
`;

export default DialogWrapper;
